import React from 'react'
import './Common.css'
import Logo from '../Assets/logo512.png'

const Navbar = () => {
    return (
        <div className='nav'>
            <div className='nav-left'>
                <img src={Logo} alt='logo' />
                <p>
                    <span className='nav-text'>Codie</span>
                </p>
            </div>
            <div className='nav-right'>
                {/* <a href="#product">Product</a>
                <a href="#features">Features</a>
                <a href="#platforms">Platforms</a>
                <a href="#pricing">Pricing</a> */}
                <a href="https://chrome.google.com/webstore/detail/codie/alokfiajmmedmneninfkldildipgjemf/" target='_blank' rel="noreferrer"><button>Download</button></a>
            </div>
        </div>
    )
}

export default Navbar